import { useEffect, useState } from "react";
import { StyledHotSpot } from "./MiniBestViewImage style";
import { BomItemDetails } from "../../../../../explorer/types/SpareParts/BomItemDetails";
import { TPartListHotSpot } from "../../../../../explorer/types/SpareParts/Assembly";
import { usePartDetails } from "../../../../hook/usePartDetails";
import { useReduxState } from "../../../../../explorer/redux/hooks";
import { PartDetailsProps } from "../../../../components/PartDetails/PartDetailsProps";
import { reduxStoreConfig } from "../../../../configuration/reduxStoreConfig";
import React from "react";
import { StyleguideSavioColors } from "../../../../configuration/themeSettings";

type MiniBestViewHotspotsPros = {
    transformObject: any;
    hotspots: TPartListHotSpot[];
    notifyCallout?: (callout: string) => void;
    calloutNotified?: string;
    notifyCalloutBestView?: (callout: string) => void;
    parentDimensions: {
        width: number;
        height: number;
        ratio: number;
    };
    imageDimensions: {
        width: number;
        height: number;
        ratio: number;
    };
    onSelect: any;
    parts: BomItemDetails[];
    partDetailsVisible: any;
};

export const MinibestViewHotspots = function (props: MiniBestViewHotspotsPros) {
    var timeout: NodeJS.Timeout;
    useEffect(() => {
        if (
            props.calloutNotified !== undefined &&
            props.calloutNotified !== null &&
            props.calloutNotified !== "" &&
            props.hotspots !== undefined &&
            props.hotspots !== null
        ) {
            var obj = props.hotspots.find((x) => {
                return x.value == props.calloutNotified;
            });

            clearTimeout(timeout);
            timeout = setTimeout(function () {
                if (obj !== null && obj !== undefined) {
                    var newX =
                        (obj.x1 + (obj.x2 - obj.x1) / 2) *
                            props.transformObject.instance.transformState
                                .scale *
                            -1 +
                        props.parentDimensions.width / 2;
                    var newY =
                        (obj.y1 + (obj.y2 - obj.y1) / 2) *
                            props.transformObject.instance.transformState
                                .scale *
                            -1 +
                        props.parentDimensions.height / 2;

                    if (newX > 0) newX = 0;
                    if (newY > 0) newY = 0;

                    if (
                        props.parentDimensions.width - newX >
                        props.imageDimensions.width *
                            props.transformObject.instance.transformState.scale
                    )
                        newX =
                            newX +
                            (props.parentDimensions.width -
                                newX -
                                props.imageDimensions.width *
                                    props.transformObject.instance
                                        .transformState.scale);
                    if (
                        props.parentDimensions.height - newY >
                        props.imageDimensions.height *
                            props.transformObject.instance.transformState.scale
                    )
                        newY =
                            newY +
                            (props.parentDimensions.height -
                                newY -
                                props.imageDimensions.height *
                                    props.transformObject.instance
                                        .transformState.scale);

                    if (
                        newX <
                            props.transformObject.instance.transformState
                                .positionX -
                                props.parentDimensions.width / 2 ||
                        newX >
                            props.transformObject.instance.transformState
                                .positionX +
                                props.parentDimensions.width / 2 ||
                        newY <
                            props.transformObject.instance.transformState
                                .positionY -
                                props.parentDimensions.height / 2 ||
                        newY >
                            props.transformObject.instance.transformState
                                .positionY +
                                props.parentDimensions.height / 2
                    ) {
                        props.transformObject.setTransform(
                            newX,
                            newY,
                            props.transformObject.instance.transformState.scale
                        );
                    }
                }
            }, 500);
        }
    }, [props.calloutNotified]);

    const partDetail = (part: string, position: string) => {
        const partInfo = getPartInfo(part, position);
        if (partInfo?.showBasket)
            props.onSelect(
                part,
                partInfo.replacementCode,
                partInfo.manufacturer,
                partInfo.position,
                partInfo.parentNaturalKey,
                partInfo
            );
    };

    const getPartInfo = (
        code: string,
        position: string
    ): BomItemDetails | undefined => {
        return props.parts.find((part, index) => {
            return part.code === code && "" + part.position === position;
        });
    };

    const [clicked, setClicked] = useState(".");

    const [partDetailsProps, setPartDetailsProps] =
        useReduxState<PartDetailsProps>(reduxStoreConfig.sparePartsPartDetails);

    const renderHotSpot = (hotspot: TPartListHotSpot, idx: number) => {
        return (
            <StyledHotSpot
                sx={{
                    zIndex:
                        props.calloutNotified !== undefined &&
                        hotspot.value === props.calloutNotified
                            ? 100000
                            : undefined,

                    top: hotspot.y1 - 10 + "px",
                    left: hotspot.x1 - 10 + "px",
                    backgroundColor:
                        (props.calloutNotified !== undefined &&
                            props.calloutNotified !== "" &&
                            hotspot.value === props.calloutNotified) ||
                        (clicked === hotspot.value && partDetailsProps.open)
                            ? StyleguideSavioColors.mainBlue
                            : StyleguideSavioColors.lightGrey,
                    color:
                        (props.calloutNotified !== undefined &&
                            props.calloutNotified !== "" &&
                            hotspot.value === props.calloutNotified) ||
                        (clicked === hotspot.value && partDetailsProps.open)
                            ? StyleguideSavioColors.lightGrey
                            : StyleguideSavioColors.mainBlue,
                }}
                aria-label="add"
                onClick={(event) => {
                    setClicked(hotspot.value);
                    partDetail(hotspot.code, hotspot.value);
                }}
                onMouseOver={() => {
                    setClicked(".");
                    if (props.notifyCalloutBestView !== undefined) {
                        props.notifyCalloutBestView("");
                    }

                    if (props.notifyCallout !== undefined) {
                        props.notifyCallout(hotspot.value);
                    }
                }}
                onMouseOut={() => {
                    if (clicked === ".") {
                        if (props.notifyCalloutBestView !== undefined) {
                            props.notifyCalloutBestView("");
                        }
                        if (props.notifyCallout !== undefined)
                            props.notifyCallout("");
                    }
                }}
                key={
                    "hs_" +
                    hotspot.value +
                    "_" +
                    hotspot.x1 +
                    "_" +
                    hotspot.y1 +
                    "_" +
                    idx
                }
            >
                {hotspot.value}
            </StyledHotSpot>
        );
    };

    if (
        props.hotspots === undefined ||
        props.hotspots === null ||
        props.hotspots.length == 0
    )
        return <React.Fragment></React.Fragment>;

    return (
        <React.Fragment>
            {props.hotspots.map((hotspot, index) => {
                return renderHotSpot(hotspot, index);
            })}
        </React.Fragment>
    );
};
